import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function QualityRing({
  score,
  size = 48
}: {
  score: number;
  size?: number;
}) {
  const radius = (size - 8) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - score / 100 * circumference;
  const color = score >= 80 ? 'text-emerald-500' : score >= 60 ? 'text-amber-500' : 'text-red-500';
  return <div className="relative flex items-center justify-center" style={{
    width: size,
    height: size
  }} data-id="element-3643">
      <svg className="transform -rotate-90" style={{
      width: size,
      height: size
    }} data-id="element-3644">
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="currentColor" strokeWidth="6" fill="transparent" className="text-gray-100" data-id="element-3645" />
        <motion.circle cx={size / 2} cy={size / 2} r={radius} stroke="currentColor" strokeWidth="6" fill="transparent" strokeDasharray={circumference} initial={{
        strokeDashoffset: circumference
      }} animate={{
        strokeDashoffset
      }} transition={{
        duration: 1.2,
        ease: 'easeOut'
      }} className={color} strokeLinecap="round" data-id="element-3646" />
      </svg>
      <span className="absolute text-sm font-bold text-gray-900" data-id="element-3647">{score}%</span>
    </div>;
}
export function ProgressBar({
  value,
  color = 'bg-blue-500',
  label
}: {
  value: number;
  color?: string;
  label?: string;
}) {
  return <div data-id="element-3648">
      {label && <div className="flex justify-between text-xs mb-1" data-id="element-3649">
          <span className="text-gray-600" data-id="element-3650">{label}</span>
          <span className="font-medium text-gray-700" data-id="element-3651">{value}%</span>
        </div>}
      <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-3652">
        <motion.div initial={{
        width: 0
      }} animate={{
        width: `${value}%`
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className={`h-full rounded-full ${color}`} data-id="element-3653" />
      </div>
    </div>;
}
export const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05
    }
  }
};
export const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 24
    }
  }
};